import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { MaxtrackService } from 'src/app/core/services/maxtrack.service';
import { StatusService } from 'src/app/core/services/status.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';

@Component({
  selector: 'app-mxt-status',
  templateUrl: './mxt-status.component.html',
  styleUrls: ['./mxt-status.component.scss'],
  providers: [DatePipe],
})
export class MxtStatusComponent implements OnInit {
  circularProgressiveWait = false;
  packet = '';
  status: Status[] = [];
  seriais = '';
  tabActiveId: number = 1;
  public prettyEvent: string = '0';

  filterKey: string[] = [];
  filterValue: any[] = [];

  constructor(
    private maxtrackService: MaxtrackService,
    private statusService: StatusService,
    public datePipe: DatePipe,
    private _clipboardService: ClipboardService,
    public toastService: ToastService
  ) {}

  ngOnInit(): void {}
  changeTab(item: any) {
    this.tabActiveId = item.activeId;
    this.seriais = '';
    this.status = [];
    this.packet = '';
  }

  search() {
    switch (this.tabActiveId) {
      case 1:
        this.searchStatus();
        break;
      case 2:
        this.searchPresetBWS();
        this.prettyEvent = '2';
        break;
      case 3:
        this.searchPresetSuntech();
        this.prettyEvent = '1';
        break;

      default:
        break;
    }
  }

  searchPresetSuntech() {
    this.status = [];
    var serialList = this.seriais.replace(' ', '').split(';');
    this.circularProgressiveWait = true;
    serialList = serialList.filter((v, i, a) => a.indexOf(v) === i);
    this.statusService.statussuntech(serialList).subscribe((response: any) => {
      try {
        if (response != '') {
          let responseJSON = JSON.parse(response);
          if (responseJSON.length > 0) {
            responseJSON.forEach((item: string) => {
              let itemJson = JSON.parse(item);
              let itemSeriais = Object.keys(itemJson);
              let valueJson = JSON.parse(
                '{ "datetime":"", "datetimeUpdateByCommand":"","tipoPreset":"","status": {"config":"sem resultados"}}'
              );
              let itemJsonKeys = Object.keys(valueJson);

              itemJsonKeys.forEach((itemJsonKeysItem: any) => {
                if (itemJson[itemSeriais[0]][itemJsonKeysItem] != '') {
                  valueJson[itemJsonKeysItem] = {};
                  valueJson[itemJsonKeysItem] =
                    itemJson[itemSeriais[0]][itemJsonKeysItem];
                }
                try {
                  if (itemJsonKeysItem == 'status') {
                    valueJson[itemJsonKeysItem] = JSON.parse(
                      valueJson[itemJsonKeysItem]
                    );
                  }
                } catch (e) {}
                try {
                  valueJson[itemJsonKeysItem] = this.datePipe.transform(
                    new Date(
                      Number(valueJson[itemJsonKeysItem]) - 3600 * 3
                    ).toUTCString(),
                    'dd-MM-yyyy HH:mm:ss'
                  );
                } catch (error: any) {
                  console.log(valueJson[itemJsonKeysItem]);
                  console.log(error.toString());
                }
              });

              this.status.push({
                serial: itemSeriais[0],
                status: valueJson,
              });
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    });
    this.circularProgressiveWait = false;
  }

  searchPresetBWS() {
    this.status = [];
    var serialList = this.seriais.replace(' ', '').split(';');
    this.circularProgressiveWait = true;
    serialList = serialList.filter((v, i, a) => a.indexOf(v) === i);
    this.statusService.statusbws(serialList).subscribe((response: any) => {
      try {
        if (response != '') {
          let responseJSON = JSON.parse(response);
          if (responseJSON.length > 0) {
            responseJSON.forEach((item: string) => {
              let itemJson = JSON.parse(item);
              let itemSeriais = Object.keys(itemJson);
              let valueJson = JSON.parse(
                '{ "datetime":"","status": {"config":"sem resultados"}}'
              );
              let itemJsonKeys = Object.keys(valueJson);

              itemJsonKeys.forEach((itemJsonKeysItem: any) => {
                if (itemJson[itemSeriais[0]][itemJsonKeysItem] != '') {
                  valueJson[itemJsonKeysItem] = {};
                  valueJson[itemJsonKeysItem] =
                    itemJson[itemSeriais[0]][itemJsonKeysItem];
                }
                try {
                  valueJson[itemJsonKeysItem] = this.datePipe.transform(
                    new Date(
                      Number(valueJson[itemJsonKeysItem]) - 3600 * 3
                    ).toUTCString(),
                    'dd-MM-yyyy HH:mm:ss'
                  );
                } catch (error: any) {
                  console.log(valueJson[itemJsonKeysItem]);
                  console.log(error.toString());
                }
              });

              this.status.push({
                serial: itemSeriais[0],
                status: valueJson,
              });
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    });
    this.circularProgressiveWait = false;
  }

  searchStatus() {
    this.filterKey = [];
    this.filterValue = [];
    this.status = [];
    var serialList = this.seriais.replace(' ', '').split(';');
    this.circularProgressiveWait = true;

    serialList = serialList.filter((v, i, a) => a.indexOf(v) === i);
    this.maxtrackService.status(serialList).subscribe((response: any) => {
      try {
        if (response != '') {
          let responseJSON = JSON.parse(response);
          if (responseJSON.length > 0) {
            responseJSON.forEach((item: string) => {
              let itemJson = JSON.parse(item);
              let itemSeriais = Object.keys(itemJson);
              let valueJson = JSON.parse(
                '{"status": {"status":"sem resultados"},"status_p2p":{"status":"sem resultados"}}'
              );
              let itemJsonKeys = Object.keys(valueJson);

              itemJsonKeys.forEach((itemJsonKeysItem: any) => {
                if (itemJson[itemSeriais[0]][itemJsonKeysItem] != '') {
                  valueJson[itemJsonKeysItem] = itemJson[itemSeriais[0]][itemJsonKeysItem];

                  const aux = itemJson[itemSeriais[0]][itemJsonKeysItem]
                    .split('')
                    .filter((char: string) => {
                      const code = char.charCodeAt(0);
                      return code >= 32 && code <= 126;
                    })
                    .join('');
                  try {
                    valueJson[itemJsonKeysItem] = JSON.parse(aux);

                    try {
                      valueJson[itemJsonKeysItem].dateTime =
                        this.datePipe.transform(
                          new Date(
                            valueJson[itemJson].dateTime * 1000
                          ).toUTCString(),
                          'dd-MM-yyyy HH:mm:ss'
                        )!;
                    } catch (error) {}
                    try {
                      valueJson[itemJsonKeysItem].dateTime =
                        this.datePipe.transform(
                          new Date(
                            valueJson[itemJsonKeysItem].dateTime * 1000
                          ).toUTCString(),
                          'dd-MM-yyyy HH:mm:ss'
                        )!;
                    } catch (error) {}
                    try {
                      if (valueJson[itemJsonKeysItem].files.length > 0) {
                        valueJson[itemJsonKeysItem].files.forEach(
                          (file: any) => {
                            try {
                              if (file.build > 0) {
                                file.build = this.datePipe.transform(
                                  new Date(file.build * 1000).toUTCString(),
                                  'dd-MM-yyyy HH:mm:ss'
                                )!;
                              }
                            } catch (error) {}
                            try {
                              if (file.appliedDate > 0) {
                                file.appliedDate = this.datePipe.transform(
                                  new Date(
                                    file.appliedDate * 1000
                                  ).toUTCString(),
                                  'dd-MM-yyyy HH:mm:ss'
                                )!;
                              }
                            } catch (error) {}
                          }
                        );
                      }
                    } catch (error) {}
                  } catch (error) {}
                }
              });
              let keys = Object.keys(valueJson.status);
              this.filterKey = this.filterKey.concat(keys);
              let keysFile: any[] = [];
              let keysFileIndex: string[] = [];
              if (keys.includes('files')) {
                valueJson.status.files.forEach(
                  (itemFile: any, index: number) => {
                    let aux = { fileType: '', value: '' };
                    aux.fileType = `file_${index}|${itemFile.fileType}`;
                    keysFileIndex.push(aux.fileType);
                    if (!aux.fileType.endsWith('FT_PROFILE')) {
                      aux.value = `${itemFile.downloadState} - ${itemFile.major}.${itemFile.minor}.${itemFile.patch}`;
                    } else {
                      aux.value = `${itemFile.downloadState} - FileId:${itemFile.fileID} - CRC:${itemFile.fileCrc32}`;
                    }
                    keysFile.push(aux);

                    if (!this.filterKey.includes(aux.fileType)) {
                      this.filterKey.push(aux.fileType);
                    }
                  }
                );
              }
              this.filterKey = this.filterKey.filter(
                (v, i, a) => a.indexOf(v) === i && v !== 'files'
              );

              this.filterKey.forEach((keyAux: string, keyIndex) => {
                if (this.filterValue.length <= keyIndex) {
                  this.filterValue.push([]);
                }
                if (keyAux.startsWith('file')) {
                  let indexKeyFile = keysFileIndex.lastIndexOf(keyAux);
                  this.filterValue[keyIndex] = this.filterValue[
                    keyIndex
                  ].concat(Object(keysFile[indexKeyFile])['value']);
                } else {
                  let value = Object(valueJson.status)[keyAux];
                  if (value == undefined) {
                    if (keyAux == 'deviceID') {
                      value = itemSeriais[0];
                    } else {
                      try {
                        value = JSON.stringify(
                          Object(valueJson.status)[keyAux]
                        );
                      } catch (e) {}
                    }
                  }
                  this.filterValue[keyIndex] = this.filterValue[
                    keyIndex
                  ].concat([value]);
                }
              });
              this.status.push({
                serial: itemSeriais[0],
                status: valueJson,
              });
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.circularProgressiveWait = false;
    });
  }
  getStatus(item: any) {
    return item.status;
  }
  getdate2(item: any) {
    return item.status.datetime;
  }
  getdate3(item: any) {
    return item.status.datetimeUpdateByCommand;
  }
  getdate(item: any) {
    return item.status.status.dateTime;
  }

  copyToClipboardMXT(): void {
    let itemHeader = '';
    let item = '';
    this.filterKey.forEach((key: string, i) => {
      itemHeader = `${itemHeader}${i == 0 ? '' : '\t'}${key}`;
    });
    for (let row = 0; row < this.filterValue[0].length; row++) {
      for (let col = 0; col < this.filterKey.length; col++) {
        item = `${item}${col == 0 ? '' : '\t'}${this.filterValue[col][row]}`;
      }
      item = `${item}\n`;
    }
    item = `${itemHeader}\n${item}`;
    try {
      this._clipboardService.copy(item);
      this.toastService.show('Copiado para a área de transferência', {
        classname: 'bg-success text-center text-white',
        delay: 2500,
      });
    } catch (error: any) {
      this.toastService.show('Erro ao copiar', {
        classname: 'bg-danger text-center text-white',
        delay: 10000,
      });
    }
  }
}

export class Status {
  serial?: string;
  status?: string;
}
